module.exports = {
    "i-services": {
        "404": "404",
        "adresa": "Адреса",
        "advertising": "Реклама",
        "afisha": "Афиша",
        "all": "Все сервисы",
        "api": "API",
        "appmetrica": "AppMetrica",
        "appsearch": "Приложения",
        "audience": "Аудитории",
        "auto": "Авто",
        "autoru": "Авто.ру",
        "avia": "Авиабилеты",
        "aziada": "Азиада",
        "ba": "Баян",
        "backapv": "Партнер Я.Карт",
        "balance": "Баланс",
        "bar": "Бар",
        "bar-ie": "Бар для ИЕ",
        "bar-ie9": "Бар для ИЕ9",
        "bayan": "Баннеры Яндекса",
        "blogs": "Блоги",
        "books": "Книги",
        "browser": "Браузер",
        "calendar": "Календарь",
        "captcha": "ой...",
        "catalogwdgt": "Каталог виджетов",
        "chrome": "Хром с поиском Яндекса",
        "city": "Города",
        "cityday": "День города",
        "clickhouse": "ClickHouse",
        "collection": "Коллекция",
        "company": "Компания",
        "contest": "Contest",
        "delivery": "Доставка",
        "desktop": "Персональный поиск",
        "direct": "Директ",
        "direct.market": "Маркет",
        "disk": "Диск",
        "display": "Дисплей",
        "ege": "ЕГЭ",
        "expert": "Эксперт",
        "feedback": "Обратная связь",
        "feedback2": "Обратная связь",
        "ff": "ФФ с поиском Яндекса",
        "fotki": "Фотки",
        "fresh": "Свежее",
        "games": "Игрушки",
        "geocontext": "Геоконтекст",
        "goroda": "Города",
        "help": "Помощь",
        "i": "Мои сервисы",
        "ie": "ИЕ с поиском Яндекса",
        "images": "Картинки",
        "images-com": "Картинки",
        "interests": "Интересы",
        "internet": "Интернет",
        "kassa": "Касса",
        "keyboard": "Клавиатура",
        "kraski": "Краски",
        "kuda": "Куда все идут",
        "large": "Яндекс для слабовидящих",
        "legal": "Правовые документы",
        "lenta": "Лента",
        "libra": "Библиотека",
        "literacy": "Неделя борьбы за грамотность",
        "local": "Локальная сеть",
        "lost": "Незабудки",
        "love": "День взаимного тяготения — 13 августа",
        "mail": "Почта",
        "maps": "Карты",
        "maps-wiki": "Народная карта",
        "market": "Маркет",
        "market.advertising": "Маркет",
        "master": "Мастер",
        "metrika": "Метрика",
        "metro": "Метро",
        "mobile": "Мобильный",
        "moikrug": "Мой Круг",
        "money": "Деньги",
        "museums": "Дни исторического и культурного наследия",
        "music": "Музыка",
        "music-partner": "Музыка: статистика",
        "nahodki": "Мои находки",
        "nano": "Нано",
        "newhire": "Наниматор",
        "news": "Новости",
        "notifications": "Нотификационная панель",
        "oauth": "Авторизация",
        "online": "Онлайн",
        "openid": "OpenID",
        "opera": "Opera Software",
        "opinion": "Цитаты",
        "partners": "Рекламная сеть",
        "partnersearch": "Поиск для партнеров",
        "passport": "Паспорт",
        "pdd": "Почта для домена",
        "peoplesearch": "Люди",
        "perevod": "Переводчик",
        "probki": "Пробки",
        "pulse": "блоги: пульс",
        "punto": "Punto switcher",
        "pvo": "Ответы",
        "rabota": "Работа",
        "radar": "Радар",
        "ramazan": "",
        "rasp": "Расписания",
        "realty": "Недвижимость",
        "referats": "Рефераты",
        "rk": "Есть вопросы?",
        "root": "Яндекс.Олимпиада для Unix администраторов",
        "school": "Школа",
        "search": "Поиск",
        "server": "Сервер",
        "shtrafi": "Штрафы",
        "site": "Поиск для сайта",
        "slovari": "Словари",
        "so": "Самооборона",
        "social": "Социализм",
        "soft": "Программы",
        "sport": "Спорт",
        "sprav": "Справочник",
        "start": "Стартовая страница",
        "stat": "Статистика",
        "subs": "Подписки",
        "taxi": "Такси",
        "telephony": "Телефония",
        "terms": "Разговорник",
        "tests": "Тесты и опросы",
        "tickets": "Билеты",
        "time": "Яндекс.Время",
        "toloka": "Яндекс.Толока",
        "toster": "Тосты",
        "translate": "Переводчик",
        "tune": "Настройки",
        "tv": "ТВ",
        "uslugi": "Услуги",
        "video": "Видео",
        "video-com": "Видео",
        "vno": "ВНО",
        "wdgt": "Виджеты",
        "weather": "Погода",
        "webmaster": "Вебмастер",
        "webmaster-api": "API Вебмастера",
        "widgets": "Виджеты",
        "wordstat": "Статистика",
        "wow": "Я.ру",
        "www": "Поиск",
        "xmlsearch": "XML",
        "yaca": "Каталог",
        "yamb": "Медийные баннеры",
        "zakladki": "Закладки"
    }
};